/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['../appContext',
    '../entities/dynamicValue',
    '../utils/tools'],
function (app, dynamicValue, tools) {
    "use strict";

    var analysis = {};

    // This function will perform a calculation for analysis from the passed in ref analysis mvc and the property that it's calculating for...Al
    analysis.calculatedAggregate = function (forProp, refMvc) {
        if (!refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs ||
            refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs.length == 0) {
            // Ungrouped calculations...AL
            return { grouped: false, values: processUngrouped(forProp, refMvc) };
        }
        else {
            // Grouped calculations...AL
            return { grouped: true, values: processGrouped(forProp, refMvc) };
        }
    };

    analysis.updateRecords = function (mvcInstance, analysisObj, analysisCol) {
        var currRec,
            currGV,
            currAnalysisObj,
            recordsArray = mvcInstance.records.Values;

        if (analysisObj != null && analysisObj.values != null && analysisObj.values.Values.length != 0) {
            if (analysisObj.grouped == true) {
                for (var k = 0, l = recordsArray.length; k < l; k++) {
                    currRec = recordsArray[k];
                    currAnalysisObj = analysisObj.values.getVal(currRec.clientRecord.Record.Code);
                    if (currAnalysisObj != null) {
                        currGV = currRec.gridValues.getVal(currAnalysisObj.value.PropertyID);
                        currGV.dynamicValue.Value = currAnalysisObj.value.Value;
                        currGV.displayProperties.setText(currAnalysisObj.value.Value);
                        //We have to call the recalcExpressions ourselves as it won't get called in the gridValue.setValue (because we set the dynamic value's value property)...TD
                        app.dv.entities.gridValue.recalcExpressions(currGV);
                    }
                    else {
                        //By setting the dynamic value's value property before setting displayProperties.Text, we prevent it from actually "editing" the value (and showing dirty)...TD
                        currGV = currRec.gridValues.getVal(analysisCol.property.PropertyID);
                        currGV.dynamicValue.Value = null;
                        currGV.displayProperties.setText("");
                        //We have to call the recalcExpressions ourselves as it won't get called in the gridValue.setValue (because we set the dynamic value's value property)...TD
                        app.dv.entities.gridValue.recalcExpressions(currGV);
                    }
                }
            }
            else {
                var currLV = analysisObj.values.Values[0];
                if (recordsArray.length > 0) {
                    currRec = recordsArray[0];
                    currLV.value.RecordID = currRec.clientRecord.Record.RecordID;
                    currGV = currRec.gridValues.getVal(analysisCol.property.PropertyID);
                    currGV.dynamicValue.Value = currLV.value.Value;
                    currGV.displayProperties.setText(currLV.value.Value);

                    for (var k = 1, l = recordsArray.length ; k < l; k++) {
                        currRec = recordsArray[k];
                        currRec.gridValues.getVal(analysisCol.property.PropertyID).dynamicValue.Value = "";
                    }
                }
            }
            return true;
        }
        else if(analysisObj.values != null) {
            for (var i = 0; i < recordsArray.length; i++) {
                currRec = recordsArray[i];
                currGV = currRec.gridValues.getVal(analysisCol.property.PropertyID);
                //By setting the dynamic value's value property before setting displayProperties.Text, we prevent it from actually "editing" the value (and showing dirty)...TD
                currGV.dynamicValue.Value = null;
                currGV.displayProperties.setText("");
                app.dv.entities.gridValue.recalcExpressions(currGV);
            }
            return true;
        }
        else{
            //Aggregate property is misconfigured, clear out any previous records and return false...TB
            for (var i = 0; i < recordsArray.length; i++) {
                currRec = recordsArray[i];
                currGV = currRec.gridValues.getVal(analysisCol.property.PropertyID);
                //By setting the dynamic value's value property before setting displayProperties.Text, we prevent it from actually "editing" the value (and showing dirty)...TD
                currGV.dynamicValue.Value = null;
                currGV.displayProperties.setText("");
            }
            return false;
        }
    };

    // This function will calculate the aggregations for ungrouped analysis...AL
    function processUngrouped(destProp, refMvc) {

        var forProp;
        switch (destProp.Definition.AggregateType) {

            // #region Count
            case app.dv.types.AggregateTypes.Count:
                var currRec,
                    currVal,
                    valArr = new tools.dictionary(),
                    calcVal = 0;

                // If no ref property id was specified, then just return the count of the records...AL
                if (destProp.Definition.RefPropertyID == null) {
                    calcVal = refMvc.records.Values.length;
                }
                else {
                    for (var i = 0; i < refMvc.records.Values.length; i++) {
                        currRec = refMvc.records.Values[i];
                        currVal = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                        if (currVal != null && currVal.dynamicValue.Value)
                            calcVal++; // The dynamic value actually has a value - add to count...AL
                    }
                }

                valArr.add(
                "<UnGrouped>",
                    {
                        group: "<UnGrouped>",
                        value: new dynamicValue.DynamicValue(calcVal, destProp, 0, null, 0)
                    });

                return valArr;
                // #endregion

                // #region Sum
            case app.dv.types.AggregateTypes.Sum:
                forProp = app.dv.cache.properties.allProperties.getVal(destProp.Definition.RefPropertyID);
                if (forProp != null) {
                    if (forProp.Definition.DataType == app.dv.types.PropertyDataType.Decimal ||
                        forProp.Definition.DataType == app.dv.types.PropertyDataType.Integer) {

                        var currRec,
                            currVal,
                            valArr = new tools.dictionary(),
                            calcVal = 0;

                        for (var i = 0; i < refMvc.records.Values.length; i++) {
                            currRec = refMvc.records.Values[i];
                            currVal = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                            if (currVal != null && currVal.dynamicValue.Value) {
                                calcVal = calcVal + getGridValueByType(currVal); // The dynamic value actually has a value - add to sum...AL
                            }
                        }

                        valArr.add(
                        "<UnGrouped>",
                            {
                                group: "<UnGrouped>",
                                value: new dynamicValue.DynamicValue(calcVal, destProp, 0, null, 0)
                            });

                        return valArr;
                    }
                }
                else return null // Not numeric...AL
                // #endregion

                // #region Average
            case app.dv.types.AggregateTypes.Average:
                forProp = app.dv.cache.properties.allProperties.getVal(destProp.Definition.RefPropertyID);
                if (forProp != null) {
                    if (forProp.Definition.DataType == app.dv.types.PropertyDataType.Decimal ||
                        forProp.Definition.DataType == app.dv.types.PropertyDataType.Integer) {

                        var currRec,
                            currVal,
                            valArr = new tools.dictionary(),
                            calcVal = 0;

                        for (var i = 0; i < refMvc.records.Values.length; i++) {
                            currRec = refMvc.records.Values[i];
                            currVal = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                            if (currVal != null && currVal.dynamicValue.Value) {
                                calcVal = calcVal + getGridValueByType(currVal); // The dynamic value actually has a value - add to sum...AL
                            }
                        }

                        // Now calculate the average...AL
                        calcVal = calcVal / refMvc.records.Values.length;

                        valArr.add(
                        "<UnGrouped>",
                            {
                                group: "<UnGrouped>",
                                value: new dynamicValue.DynamicValue(calcVal, destProp, 0, null, 0)
                            });

                        return valArr;
                    }
                }
                else return null // Not numeric...AL
                // #endregion

                // #region Min
            case app.dv.types.AggregateTypes.Min:
                var currRec,
                    currVal,
                    valArr = new tools.dictionary(),
                    calcVal;

                for (var i = 0; i < refMvc.records.Values.length; i++) {
                    currRec = refMvc.records.Values[i];
                    currVal = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                    if (currVal != null && currVal.dynamicValue.Value) {
                        let checkVal = getGridValueByType(currVal);
                        if (!calcVal) calcVal = checkVal;
                        else calcVal = checkVal < calcVal ? checkVal : calcVal;
                    }
                }

                valArr.add(
                "<UnGrouped>",
                    {
                        group: "<UnGrouped>",
                        value: new dynamicValue.DynamicValue(calcVal, destProp, 0, null, 0)
                    });

                return valArr;
                // #endregion

                // #region Max
            case app.dv.types.AggregateTypes.Max:
                var currRec,
                    currVal,
                    valArr = new tools.dictionary(),
                    calcVal;

                for (var i = 0; i < refMvc.records.Values.length; i++) {
                    currRec = refMvc.records.Values[i];
                    currVal = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                    if (currVal != null && currVal.dynamicValue.Value) {
                        let checkVal = getGridValueByType(currVal);
                        if (!calcVal) calcVal = checkVal;
                        else calcVal = checkVal > calcVal ? checkVal : calcVal;
                    }
                }

                valArr.add(
                "<UnGrouped>",
                    {
                        group: "<UnGrouped>",
                        value: new dynamicValue.DynamicValue(calcVal, destProp, 0, null, 0)
                    });

                return valArr;
                // #endregion

            default: return null;
        }
    }

    // This function will calculate the aggregations for grouped analysis...AL
    function processGrouped(destProp, refMvc) {

        switch (destProp.Definition.AggregateType) {

            // #region Count
            case app.dv.types.AggregateTypes.Count:
                var currRec,
                    calcVal,
                    valArr = new tools.dictionary(),
                    checkVal = null;

                // If no ref property id was specified, then just return the count of the records...AL
                if (destProp.Definition.RefPropertyID == null) {
                    for (var i = 0; i < refMvc.records.Values.length; i++) {
                        currRec = refMvc.records.Values[i];
                        calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                        checkVal = valArr.getVal(calcVal);

                        if (!checkVal) {
                            valArr.add(calcVal, {
                                group: calcVal,
                                value: new dynamicValue.DynamicValue(1, destProp, 0, null, 0)
                            });
                        }
                        else {
                            checkVal.value.Value++;
                        }
                    }
                }
                else {

                    for (var i = 0; i < refMvc.records.Values.length; i++) {
                        currRec = refMvc.records.Values[i];
                        calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                        checkVal = valArr.getVal(calcVal);

                        if (!checkVal) {
                            valArr.add(calcVal, {
                                group: calcVal,
                                value: new dynamicValue.DynamicValue(1, destProp, 0, null, 0)
                            });
                        }
                        else {
                            checkVal.value.Value++;
                        }

                    }
                }
                return valArr;
                // #endregion

                // #region Sum
            case app.dv.types.AggregateTypes.Sum:
                var currRec,
                    calcVal,
                    valArr = new tools.dictionary(),
                    checkVal = null,
                    forProp = app.dv.cache.properties.allProperties.getVal(destProp.Definition.RefPropertyID);

                if (forProp.Definition.DataType == app.dv.types.PropertyDataType.Decimal ||
                    forProp.Definition.DataType == app.dv.types.PropertyDataType.Integer) {

                    for (var i = 0; i < refMvc.records.Values.length; i++) {
                        currRec = refMvc.records.Values[i];
                        calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                        checkVal = null;

                        var sv = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);

                        if (sv != null) {
                            // This will always be a number grid val
                            var thisGridVal = app.dv.entities.gridValue.getNumberValue(sv);
                            if (thisGridVal != null) {
                                checkVal = valArr.getVal(calcVal);

                                if (!checkVal) {
                                    valArr.add(calcVal, {
                                        group: calcVal,
                                        value: new dynamicValue.DynamicValue(thisGridVal, destProp, 0, null, 0)
                                    });
                                }
                                else {
                                    checkVal.value.Value = checkVal.value.Value + thisGridVal;
                                }
                            }
                        }
                    }

                    return valArr;
                }
                else return null; // Not numeric...AL
                // #endregion

                // #region Average
            case app.dv.types.AggregateTypes.Average:
                var currRec,
                    calcVal,
                    valArr = new tools.dictionary(),
                    checkVal = null,
                    forProp = app.dv.cache.properties.allProperties.getVal(destProp.Definition.RefPropertyID);

                if (forProp.Definition.DataType == app.dv.types.PropertyDataType.Decimal ||
                    forProp.Definition.DataType == app.dv.types.PropertyDataType.Integer) {

                    for (var i = 0; i < refMvc.records.Values.length; i++) {
                        currRec = refMvc.records.Values[i];
                        calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                        checkVal = null;

                        var sv = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);
                        if (sv != null) {
                            var thisGridVal = app.dv.entities.gridValue.getNumberValue(sv);

                            if (thisGridVal != null) {
                                checkVal = valArr.getVal(calcVal);

                                if (!checkVal) {
                                    valArr.add(calcVal, {
                                        group: calcVal,
                                        value: new dynamicValue.DynamicValue(thisGridVal, destProp, 0, null, 0),
                                        grpCount: 1 //Note:  Start this count at one to take this value into account..EK
                                    });
                                }
                                else {
                                    checkVal.value.Value = checkVal.value.Value + thisGridVal;
                                    checkVal.grpCount++;
                                }
                            }
                        }
                    }

                    for (var iGrp = 0; iGrp < valArr.Values.length; iGrp++) {
                        var thisGrp = valArr.Values[iGrp];
                        if (thisGrp.value.Value > 0 && thisGrp.grpCount > 0) {    //If these conditions are not met, no average can be calculated, leave 0...EK
                            thisGrp.value.Value = thisGrp.value.Value / thisGrp.grpCount;    //Calculate the average here...EK
                        }
                    }

                    return valArr;
                }
                else return null; // Not numeric...AL
                // #endregion

                // #region Min
            case app.dv.types.AggregateTypes.Min:
                var currRec,
                    calcVal,
                    valArr = new tools.dictionary(),
                    checkVal = null;

                for (var i = 0; i < refMvc.records.Values.length; i++) {
                    currRec = refMvc.records.Values[i];
                    calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                    checkVal = null;

                    var sv = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);

                    if (sv != null) {
                        var thisGridVal = getGridValueByType(sv);

                        if (thisGridVal != null) {
                            checkVal = valArr.getVal(calcVal);

                            if (!checkVal) {
                                valArr.add(calcVal, {
                                    group: calcVal,
                                    value: new dynamicValue.DynamicValue(thisGridVal, destProp, 0, null, 0)
                                });
                            }
                            else {
                                if (thisGridVal < checkVal.value.Value)
                                    checkVal.value.Value = thisGridVal;
                            }
                        }
                    }
                }

                return valArr;
                // #endregion

                // #region Max
            case app.dv.types.AggregateTypes.Max:
                var currRec,
                    calcVal,
                    valArr = new tools.dictionary(),
                    checkVal = null;

                for (var i = 0; i < refMvc.records.Values.length; i++) {
                    currRec = refMvc.records.Values[i];
                    calcVal = currRec.calculateGridValue(refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs, createAnlysisGroupByFormula(refMvc));
                    checkVal = null;

                    var sv = currRec.gridValues.getVal(destProp.Definition.RefPropertyID);

                    if (sv != null) {
                        //var thisGridVal = app.dv.entities.gridValue.getValue(sv);
                        let thisGridVal = getGridValueByType(sv);

                        if (thisGridVal != null) {
                            checkVal = valArr.getVal(calcVal);

                            if (!checkVal) {
                                valArr.add(calcVal, {
                                    group: calcVal,
                                    value: new dynamicValue.DynamicValue(thisGridVal, destProp, 0, null, 0)
                                });
                            }
                            else {
                                if (thisGridVal > checkVal.value.Value)
                                    checkVal.value.Value = thisGridVal;
                            }
                        }
                    }
                }

                return valArr;
                // #endregion

            default: return null;
        }
    }

    // Build a string for the groups for analysis (note this is mostly deprecated - as we do not allow multiple groups)...AL
    function createAnlysisGroupByFormula(refMvc) {
        var propertyIDs = refMvc.drivingView.Definition.AnalysisGroupByPropertyIDs,
            retStr = "{"

        for (var i = 0; i < propertyIDs.length; i++) {
            retStr += i;

            if (i != propertyIDs.length - 1) retStr += "}-{";
        }

        retStr += "}";

        return retStr;
    }

    function getGridValueByType(gv) {
        switch(gv.dynamicValue.DataType) {
            case app.dv.types.PropertyDataType.Bit:
                return app.dv.entities.gridValue.getCheckValue(gv);
            case app.dv.types.PropertyDataType.Decimal:
            case app.dv.types.PropertyDataType.Integer:
                return app.dv.entities.gridValue.getNumberValue(gv);
            case app.dv.types.PropertyDataType.DateTime:
            case app.dv.types.PropertyDataType.StaticDateTime:
                return app.dv.entities.gridValue.getDateValue(gv);
            case app.dv.types.PropertyDataType.Text:
                return app.dv.entities.gridValue.getTextValue(gv);
            default:
                return null;
        }
    }

    return analysis;
});
